/* Chromium paints its default near-black focus ring on a focused <svg tabindex="0"> via plain
   :focus, not :focus-visible, so a mouse click leaves a black border behind. */
.indicator:focus:not(:focus-visible) {
	outline: none;
}

.indicator:focus-visible {
	outline: 2px solid var(--focus-outline-color-dark);
	outline-offset: 2px;
	border-radius: 2px;
}

.indicatorButton {
	width: 20px;
	height: 20px;
	padding: 0px;
}
